import DashInfoCardTotal from './DashInfoCardTotal';
export default DashInfoCardTotal;
export { default as DashInfoCardTotal } from './DashInfoCardTotal';